import type { ChemicalExemptReason } from "encamp-prisma/generated/browser";
/**
 * Human-readable labels for the 40 CFR 370.13 EPCRA 311/312 exemption
 * categories, for use in dropdowns and display. Wording is condensed from the
 * statutory language.
 */
export const EXEMPT_REASON_LABELS: Record<ChemicalExemptReason, string> = {
  FDA_REGULATED: "FDA-regulated food, drug, or cosmetic",
  MANUFACTURED_SOLID: "Solid present in a manufactured item",
  HOUSEHOLD_PRODUCTS: "Personal, family, or household product",
  LAB_RESEARCH: "Research laboratory or medical facility use",
  AGRICULTURAL_OPERATIONS: "Routine agricultural operation or fertilizer",
  OTHER: "Other",
};

// Display order for the exemption categories in dropdowns. Written as string
// literals (not enum members) so this module has no runtime dependency on the
// generated `ChemicalExemptReason` object — the annotation still type-checks each
// value against the enum. See the type-only import above.
export const EXEMPT_REASON_ORDER: ChemicalExemptReason[] = [
  "FDA_REGULATED",
  "MANUFACTURED_SOLID",
  "HOUSEHOLD_PRODUCTS",
  "LAB_RESEARCH",
  "AGRICULTURAL_OPERATIONS",
  "OTHER",
];

function isExemptReason(reason: string): reason is ChemicalExemptReason {
  return Object.prototype.hasOwnProperty.call(EXEMPT_REASON_LABELS, reason);
}

/** Returns the display label for a stored exempt reason, or null if unset. */
export function formatExemptReason(reason?: string | null): string | null {
  if (!reason) {
    return null;
  }
  if (isExemptReason(reason)) {
    return EXEMPT_REASON_LABELS[reason];
  }
  return null;
}
